import { FC, useState } from 'react';
import { AlignRightOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import styled from 'styled-components';

import { MobileMenu } from 'entities/user/ui/MobileMenu/MobileMenu';
import { toggleScroll } from 'shared/lib/scroll';
import { useCurrentUserQuery } from '../../api';

import './CurrentUserM.styles.css';

const DropdownStyled = styled(Dropdown)`
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		display: none;
	}
`;

export const CurrentUserM: FC = () => {
	const { data: user } = useCurrentUserQuery();
	const [visible, setVisible] = useState(false);

	if (!user) {
		return null;
	}

	const handleToggleVisible = (): void => {
		toggleScroll();
		setVisible(!visible);
	};

	return (
		<DropdownStyled
			overlayClassName='currentUserDropdown'
			trigger={[`click`]}
			visible={visible}
			placement='top'
			dropdownRender={() => <MobileMenu toggleVisible={handleToggleVisible} />}
		>
			<AlignRightOutlined onClick={handleToggleVisible} style={{ fontSize: `24px` }} />
		</DropdownStyled>
	);
};
